import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

export const addNewProfileModalSchema = yupResolver(
  yup.object({
    profileDescription: yup.string().required('Descrição do perfil é obrigatória'),
    profileType: yup.string().required('Tipo de perfil é obrigatório'),
    status: yup.string().required('Status é obrigatório'),
    observations: yup.string().optional()
  })
)
